import PropTypes from 'prop-types';
import { isBlank } from 'utils/helperMethods';
import i18n from 'i18n';
import Presenter from 'utils/PropTypesPresenter';

export default new Presenter(
  {
    applicationUrl: PropTypes.string,
    bundleCompanyName: PropTypes.string,
    active: PropTypes.bool,
    company: PropTypes.string,
    companyLogoUrl: PropTypes.string,
    email: PropTypes.string,
    profileImageUrl: PropTypes.string,
    loanOfficerId: PropTypes.number,
    loanOfficerName: PropTypes.string,
    location: PropTypes.string,
    mortgageCompanyNmls: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nmls: PropTypes.numbers,
    offerings: PropTypes.arrayOf(PropTypes.string),
    phoneNumber: PropTypes.string,
    apr: PropTypes.string,
    responseTime: PropTypes.string,
  },
  {
    branchLocation(loanOfficer) {
      const location = this.location(loanOfficer);
      if (isBlank(location)) return i18n.t(`presenters.realEstateAgent.LoanOfficerPresenter.notSet`);
      return location;
    },
    readableApr(loanOfficer) {
      const apr = this.apr(loanOfficer);
      if (isBlank(apr)) return '';

      return `${Number.parseFloat(apr).toFixed(3)}%`;
    },
    readableResponseTime(loanOfficer) {
      const responseTime = this.responseTime(loanOfficer);
      if (isBlank(responseTime)) return '';

      return `${Number.parseFloat(responseTime).toFixed(0)}`;
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/realEstateAgent/LoanOfficerPresenter.js